import React from 'react';

import Modal from './Modal';
import NewClientContactForm from './NewClientContactForm';

/*
Call this with
    <NewClientContactModal
        show={the condition under which it should show}
        viewingFirmId={id}
        clientId={personId}
        relationship="<pre-specified relationship, if any>" //optional
        successFunc={<(newPersonId, relationship) => a function(newPersonId, relationship) to take care of newPersonId and close the dialog>}
        closeModalFunc={a function for closing the dialog}
    />
*/

const NewClientContactModal = ({ show, viewingFirmId, clientId, relationship, successFunc, closeModalFunc }) => {
  return (
    <Modal open={show} title={'Add New Contact'} hideButtons={true} onCancel={closeModalFunc}>
      <NewClientContactForm
        viewingFirmId={viewingFirmId}
        clientId={clientId}
        relationship={relationship || ''}
        successFunc={successFunc}
        closeModalFunc={closeModalFunc}
      />
    </Modal>
  );
};

export default NewClientContactModal;
